import { take } from 'rxjs';

import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, effect, forwardRef, inject, Injector, Input, signal, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { ActivityEntityName, Entity } from '@jms/model';
import { PickerBaseComponent } from '@jms/ui/ui.pickers.base';
import { NgSelectModule } from '@ng-select/ng-select';
import { SignalInput } from '@workbuddy/utils/signals';

@Component({
    selector: 'entity-view-picker',
    templateUrl: './entity.view.picker.component.html',
    styleUrls: ['./entity.view.picker.component.less'],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        NgSelectModule,
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => EntityViewPickerComponent),
            multi: true
        }
    ]
})
export class EntityViewPickerComponent extends PickerBaseComponent {

    private readonly http = inject(HttpClient);


    @SignalInput()
    @Input({ alias: 'type', required: true }) $type = signal<ActivityEntityName>(null);

    @Input() placeholder = '<View>';
    @Input() multiple = false;
    @Input() allowClear = false;
    @Input() appendTo;
    @Input() selectableGroup = false;
    @Input() allowClose = true;

    $data = signal<Entity[]>([])

    constructor(
        injector: Injector,
    ) {
        super(injector);

        effect(() => {
            const type = this.$type();
            if (!type) {
                this.$data.set([]);
                return;
            }

            this.http.get<Entity[]>(`/api/picker/views/${this.$type()}`)
                .pipe(take(1))
                .subscribe(data => this.$data.set(data));

        })
    }

}
